// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Icon);
    global.Icon = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Icon) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IconButton = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var P_CLASS_NAMES = {
    sm: 'cop-p-2',
    base: 'cop-p-2.5'
  };
  var IconButton = _exports.IconButton = function IconButton(_ref) {
    var label = _ref.label,
      onClick = _ref.onClick,
      icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'base' : _ref$size;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: ['cop-bg-[#212B36]', 'cop-text-white', P_CLASS_NAMES[size], 'cop-rounded', 'hover:cop-opacity-80', 'cop-transition-opacity', 'cop-flex', 'cop-items-center', 'cop-shadow-none', 'cop-border-0'].join(' '),
      onClick: onClick,
      "aria-label": label
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: icon,
      className: ['cop-w-3', 'cop-h-3'].join(' ')
    })));
  };
});
